/** @format */

import angular from 'angular';
import angularTranslate from 'angular-translate';
import angularUiRouter from 'angular-ui-router';

import { AuthModule } from 'crowdcomms-js/lib/galabid/auth';
import { HelpersModule } from 'crowdcomms-js/lib/helpers';
import { I18nModule } from 'crowdcomms-js/lib/i18n';
import { LoadersModule } from 'crowdcomms-js/lib/ui/loaders';
import { OneTimeUseTokenModule } from 'crowdcomms-js/lib/galabid/one-time-use-token';
import { PusherModule } from 'crowdcomms-js/lib/realtime/pusher';
import { ProjectorModelsModule } from 'crowdcomms-js/lib/galabid/projector/models';
import { ServicesModule } from '../services';
import { ToastModule } from 'crowdcomms-js/lib/ui/toast';

import { GbAppComponent } from './gb-app/gb-app.component.js';
import { GbButtonComponent } from './gb-button/gb-button.component.js';
import { GbFullscreenOverlayComponent } from './gb-fullscreen-overlay/gb-fullscreen-overlay.component.js';
import { GbFullscreenToggleComponent } from './gb-fullscreen-toggle/gb-fullscreen-toggle.component.js';
import { GbItemLabelComponent } from './gb-item-label/gb-item-label.component.js';
import { GbItemTypeComponent } from './gb-item-type/gb-item-type.component.js';
import { GbLoaderOverlayComponent } from './gb-loader-overlay/gb-loader-overlay.component.js';
import { GbPresenterComponent } from './gb-presenter/gb-presenter.component.js';
import { GbPresenterErrorComponent } from './gb-presenter-error/gb-presenter-error.component.js';
import { GbRadioGroupDirective } from './gb-radio-group/gb-radio-group.directive.js';
import { GbRadioButtonComponent } from './gb-radio-button/gb-radio-button.component.js';
import { GbStylesComponent } from './gb-styles/gb-styles.component.js';
import { GbTablePaginationComponent } from './gb-table-pagination/gb-table-pagination.component.js';

export const SharedComponentsModule = angular
    .module('galabid-presenter.shared.components', [
        angularTranslate,
        angularUiRouter,
        AuthModule,
        HelpersModule,
        I18nModule,
        LoadersModule,
        OneTimeUseTokenModule,
        PusherModule,
        ProjectorModelsModule,
        ServicesModule,
        ToastModule,
    ])
    .component('gbApp', GbAppComponent)
    .component('gbButton', GbButtonComponent)
    .component('gbFullscreenOverlay', GbFullscreenOverlayComponent)
    .component('gbFullscreenToggle', GbFullscreenToggleComponent)
    .component('gbItemLabel', GbItemLabelComponent)
    .component('gbItemType', GbItemTypeComponent)
    .component('gbLoaderOverlay', GbLoaderOverlayComponent)
    .component('gbPresenter', GbPresenterComponent)
    .component('gbPresenterError', GbPresenterErrorComponent)
    .component('gbRadioButton', GbRadioButtonComponent)
    .component('gbStyles', GbStylesComponent)
    .component('gbTablePagination', GbTablePaginationComponent)
    .directive('gbRadioGroup', GbRadioGroupDirective).name;
